import React, { Component } from "react";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import { propertytax } from "./sopDataTemplate";

interface AllProps {
  data: propertytax;
  handlePropertytaxChange: any;
  isOnlyView?: boolean;
}
export class Propertytax extends Component<AllProps> {
  state = {
    isOptionOpen: false,
    bgColor: "#ffff8d",
    responseData: {},
  };

  componentDidMount() {
    const { data } = this.props;
    this.setState({
      responseData: JSON.parse(JSON.stringify(data)),
    });
  }

  changeBgColor = () => {
    const { bgColor } = this.state;
    if (bgColor !== "lightgreen") {
      this.setState({ bgColor: "lightgreen" });
    }
  };
  handleChange = (name, val) => {
    const { data } = this.props;
    data[name] = val;
    this.changeBgColor();
    data.bgColor = "lightgreen";
    this.props.handlePropertytaxChange(data);
  };
  handleStateChange = (stateName, value) => {
    console.log("value", value);
    this.setState(
      {
        [stateName]: value,
      },
      () => {
        this.changeBgColor();
      },
    );
  };
  handleFileChange = (name, val) => {
    const { data } = this.props;
    this.changeBgColor();
    data.bgColor = "lightgreen";
    this.props.handlePropertytaxChange(data);
  };
  getOtherProps = (key) => {
    // const { data, isOnlyView } = this.props;
    // if (isOnlyView) return { [key]: true };
    return null;
  };

  handleChildInputChange = (key, name, value, index?) => {
    const { data } = this.props;
    if (index !== undefined) data[key][index][name] = value;
    else data[key][name] = value;
    this.changeBgColor();
    data.bgColor = "lightgreen";
    this.props.handlePropertytaxChange(data);
  };
  handleChildRadioChange = (key, name, val, index?) => {
    const { data } = this.props;
    if (index !== undefined) {
      data[key][index][name] = val;
    } else {
      data[key][name] = val;
    }
    this.changeBgColor();
    data.bgColor = "lightgreen";
    this.props.handlePropertytaxChange(data);
  };

  addChild = (type) => {
    const { data } = this.props;

    // Create a copy of data or initialize a new object
    const updatedData = data ? { ...data } : {};

    // Ensure the type property exists as an array
    if (!updatedData[type] || !Array.isArray(updatedData[type])) {
      updatedData[type] = [];
    }

    // FIXED: Push to updatedData[type], not data[type]
    updatedData[type].push({
      specialTahsildar: false,
      boundaryCertificate: false,
      roadApproach: false,
    });

    this.props.handlePropertytaxChange(updatedData);
  };

  removeChild = (type, index) => {
    const { data } = this.props;
    delete data[type][index];
    const updatedLegalHeirs = data[type].filter((item) => item !== null);
    data[type] = updatedLegalHeirs;
    this.props.handlePropertytaxChange(data);
  };

getAddButton = (title: string, value: string, showRadioForSection?: boolean) => {
    const { data } = this.props;

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
            }}
        >
            <div style={{ display: "flex", alignItems: "center" }}>
                <h6 style={{ margin: 0 }}>
                    <b>{title}</b>
                </h6>

                {/* Show radio buttons only for the specified section */}
                {showRadioForSection === true && (
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            marginLeft: "20px",
                        }}
                    >
                        <Form.Check
                            inline
                            label="Yes"
                            name={`isshow${value}Status`}
                            type="radio"
                            id={`isshow${value}Status-yes`}
                            checked={data[`isshow${value}Status`] === true}
                            onChange={() => {
                                const fieldName = `isshow${value}Status`;
                                data[fieldName] = true;
                                this.changeBgColor();
                                data.bgColor = "lightgreen";
                                this.props.handlePropertytaxChange(data);
                            }}
                            style={{ marginRight: "15px" }}
                        />
                        <Form.Check
                            inline
                            label="No"
                            name={`isshow${value}Status`}
                            type="radio"
                            id={`isshow${value}Status-no`}
                            checked={data[`isshow${value}Status`] !== true}
                            onChange={() => {
                                const fieldName = `isshow${value}Status`;
                                data[fieldName] = false;
                                this.changeBgColor();
                                data.bgColor = "lightgreen";
                                this.props.handlePropertytaxChange(data);
                            }}
                        />
                    </div>
                )}
            </div>

            <div onClick={() => this.addChild(value)}>
                <button
                    className="btn btn-sm btn-primary"
                    style={{ fontSize: "smaller" }}
                >
                    Add {title}
                </button>
            </div>
        </div>
    );
};
  checkOperation = (type, value, index) => {
    let isEditable = false;
    const { responseData } = this.state;
    if (responseData[type] && responseData[type].length < index + 1) {
      isEditable = true;
    }
    return isEditable;
  };

  render() {
    const { data, isOnlyView } = this.props;
    const { isOptionOpen, bgColor } = this.state;
    console.log("data?.propertytax", data?.propertytax);

    return (
      <div className="collapse-section count-doc-verify">
        <Accordion>
          <Card>
            <Accordion.Toggle
              style={{ background: data?.bgColor ? data?.bgColor : bgColor }}
              as={Card.Header}
              eventKey="8"
              onClick={() => {
                this.setState({ isOptionOpen: !isOptionOpen });
              }}
            >
              <h5>
                <b>Property tax</b>
              </h5>
              <i
                className={`icon feather icon-${
                  !isOptionOpen ? "plus" : "minus"
                }`}
                style={{
                  color: "black",
                  fontSize: "17px",
                  fontWeight: "bold",
                  float: "right",
                }}
              />
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="8">
              <Card.Body>
                <div>
                  {this.getAddButton("Property Tax", "propertytax",true)}
                  {data?.propertytax &&
                    Array.isArray(data?.propertytax) &&
                    data?.propertytax.map((value, index) => {
                      return (
                        <>
                          <div className="row mb-10" key={index}>
                            <div className="col-md-4 mb-10">
                              <label
                                className="label mb-2"
                                style={{ padding: 0 }}
                              >
                                Date Verified
                              </label>
                              {/* {data.file.btTransfer}/ */}
                              <div className="row" style={{ marginLeft: 0 }}>
                                <input
                                  className="form-control"
                                  name={
                                    "propertytax" +
                                    (value && value.dataVerified
                                      ? value.dataVerified
                                      : "") +
                                    index
                                  }
                                  type="text"
                                  value={
                                    value && value.dataVerified
                                      ? value.dataVerified
                                      : ""
                                  }
                                  onChange={(e) =>
                                    this.handleChildInputChange(
                                      "propertytax",
                                      "dataVerified",
                                      e.target.value,
                                      index,
                                    )
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-md-3 mb-10">
                              <label
                                className="label mb-2"
                                style={{ padding: 0 }}
                              >
                                Property Owner Name Verified
                              </label>
                              <div className="row" style={{ marginLeft: 0 }}>
                                <input
                                  className="form-control"
                                  name={
                                    "propertytax" +
                                    (value && value.propertOwnerVerify
                                      ? value.propertOwnerVerify
                                      : "") +
                                    index
                                  }
                                  type="text"
                                  value={
                                    value && value.propertOwnerVerify
                                      ? value.propertOwnerVerify
                                      : ""
                                  }
                                  onChange={(e) =>
                                    this.handleChildInputChange(
                                      "propertytax",
                                      "propertOwnerVerify",
                                      e.target.value,
                                      index,
                                    )
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-md-3 mb-10">
                              <label
                                className="label mb-2"
                                style={{ padding: 0 }}
                              >
                                Amount Verified
                              </label>
                              <div className="row" style={{ marginLeft: 0 }}>
                                <input
                                  className="form-control"
                                  name={
                                    "propertytax" +
                                    (value && value.propertyAmountverify
                                      ? value.propertyAmountverify
                                      : "") +
                                    index
                                  }
                                  type="text"
                                  value={
                                    value && value.propertyAmountverify
                                      ? value.propertyAmountverify
                                      : ""
                                  }
                                  onChange={(e) =>
                                    this.handleChildInputChange(
                                      "propertytax",
                                      "propertyAmountverify",
                                      e.target.value,
                                      index,
                                    )
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-md-3 mb-10">
                              <label
                                className="label mb-2"
                                style={{ padding: 0 }}
                              >
                                Door.No Verified
                              </label>
                              <div className="row" style={{ marginLeft: 0 }}>
                                <input
                                  className="form-control"
                                  name={
                                    "propertytax" +
                                    (value && value.doorNoVerify
                                      ? value.doorNoVerify
                                      : "") +
                                    index
                                  }
                                  type="text"
                                  value={
                                    value && value.doorNoVerify
                                      ? value.doorNoVerify
                                      : ""
                                  }
                                  onChange={(e) =>
                                    this.handleChildInputChange(
                                      "propertytax",
                                      "doorNoVerify",
                                      e.target.value,
                                      index,
                                    )
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-md-3 mb-10">
                              <label
                                className="label mb-2"
                                style={{ padding: 0 }}
                              >
                                Assessment No Verified
                              </label>
                              <div className="row" style={{ marginLeft: 0 }}>
                                <input
                                  className="form-control"
                                  name={
                                    "propertytax" +
                                    (value && value.assessmentVerifi
                                      ? value.assessmentVerifi
                                      : "") +
                                    index
                                  }
                                  type="text"
                                  value={
                                    value && value.assessmentVerifi
                                      ? value.assessmentVerifi
                                      : ""
                                  }
                                  onChange={(e) =>
                                    this.handleChildInputChange(
                                      "propertytax",
                                      "assessmentVerifi",
                                      e.target.value,
                                      index,
                                    )
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-md-3 mb-10">
                              <label
                                className="label mb-2"
                                style={{ padding: 0 }}
                              >
                                Property Tax issued by Verified
                              </label>
                              <div className="row" style={{ marginLeft: 0 }}>
                                <input
                                  className="form-control"
                                  name={
                                    "propertytax" +
                                    (value && value.propertyTaxVerify
                                      ? value.propertyTaxVerify
                                      : "") +
                                    index
                                  }
                                  type="text"
                                  value={
                                    value && value.propertyTaxVerify
                                      ? value.propertyTaxVerify
                                      : ""
                                  }
                                  onChange={(e) =>
                                    this.handleChildInputChange(
                                      "propertytax",
                                      "propertyTaxVerify",
                                      e.target.value,
                                      index,
                                    )
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-md-3 mb-10">
                              <label
                                className="label mb-2"
                                style={{ padding: 0 }}
                              >
                                Property Tax Verified with QR Code
                              </label>
                              <div className="row" style={{ marginLeft: 0 }}>
                                <Form.Check
                                  inline
                                  label="Yes"
                                  name={
                                    "propertyTaxVerifyQrcode" +
                                    (value && value.propertyTaxVerifyQrcode
                                      ? value.propertyTaxVerifyQrcode
                                      : "") +
                                    index
                                  }
                                  type="radio"
                                  checked={value.propertyTaxVerifyQrcode}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "propertytax",
                                      "propertyTaxVerifyQrcode",
                                      true,
                                      index,
                                    )
                                  }
                                />
                                <Form.Check
                                  inline
                                  label="No"
                                  name={
                                    "propertyTaxVerifyQrcode" +
                                    (value && !value.propertyTaxVerifyQrcode
                                      ? !value.propertyTaxVerifyQrcode
                                      : "") +
                                    index
                                  }
                                  type="radio"
                                  checked={!value.propertyTaxVerifyQrcode}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "propertytax",
                                      "propertyTaxVerifyQrcode",
                                      false,
                                      index,
                                    )
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-md-3 mb-10">
                              <label
                                className="label mb-2"
                                style={{ padding: 0 }}
                              >
                                Attached Proof Submitted for Verified QR Code
                              </label>
                              <div className="row" style={{ marginLeft: 0 }}>
                                <Form.Check
                                  inline
                                  label="Yes"
                                  name={
                                    "attachProofVerifyQrcode" +
                                    (value && value.attachProofVerifyQrcode
                                      ? value.attachProofVerifyQrcode
                                      : "") +
                                    index
                                  }
                                  type="radio"
                                  checked={value.attachProofVerifyQrcode}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "propertytax",
                                      "attachProofVerifyQrcode",
                                      true,
                                      index,
                                    )
                                  }
                                />
                                <Form.Check
                                  inline
                                  label="No"
                                  name={
                                    "attachProofVerifyQrcode" +
                                    (value && !value.attachProofVerifyQrcode
                                      ? !value.attachProofVerifyQrcode
                                      : "") +
                                    index
                                  }
                                  type="radio"
                                  checked={!value.attachProofVerifyQrcode}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "propertytax",
                                      "attachProofVerifyQrcode",
                                      false,
                                      index,
                                    )
                                  }
                                />
                              </div>
                            </div>
                            {this.checkOperation(
                              "propertytax",
                              value,
                              index,
                            ) && (
                              <div
                                className="form-group col-md-2"
                                style={{
                                  alignSelf: "center",
                                  fontSize: "initial",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  this.removeChild("propertytax", index)
                                }
                              >
                                <i
                                  style={{ color: "red" }}
                                  className="feather icon-minus-circle"
                                />
                              </div>
                            )}
                          </div>
                        </>
                      );
                    })}
                </div>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      </div>
    );
  }
}

export default Propertytax;
